import intlPolyfill from './intl'

export default function () {
  return intlPolyfill
}



// WEBPACK FOOTER //
// ./src/application/polyfills/index.js